export function pluginHook() { return { pluginReturn: null, vueQueryPluginOptions: null}}